import { render, staticRenderFns } from "./custom_fields.vue?vue&type=template&id=fbf4208e&scoped=true&"
import script from "./custom_fields.vue?vue&type=script&lang=js&"
export * from "./custom_fields.vue?vue&type=script&lang=js&"
import style0 from "./custom_fields.vue?vue&type=style&index=0&id=fbf4208e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf4208e",
  null
  
)

export default component.exports